import { render, staticRenderFns } from "./VendorCategory.vue?vue&type=template&id=2c9aec80&scoped=true&"
import script from "./VendorCategory.vue?vue&type=script&lang=js&"
export * from "./VendorCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9aec80",
  null
  
)

export default component.exports